export default __webpack_public_path__ + "static/media/fa-brands-400.89a52ae1.eot";